// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3daf2914","732":"96b79494","977":"80d0d573"}[chunkId] + ".chunk.js";
};